<div class="dialog-container">
  <h2 mat-dialog-title>{{data.title}}</h2>
  <div mat-dialog-content [innerHTML]="data.content">
  </div>
  <div mat-dialog-actions>
    <button id="dialog-close" class="btns mat-raised-button" mat-button mat-dialog-close cdkFocusInitial>Close</button>
  </div>
</div>
